

export const RouteUrls = {
  login: "login",
  hs: "hs",
  notfound: "notfound",
  list: "list",
  orders: "orders",
  home: "home",
  dashboard: "dashboard",
  chat: "chat",
  user: "user",
  register: "register",
  customer: "customer",
  professional: "professional",
  corporate: "corporate",
  case: "case",
  caseCreation: "case-creation",
  payment: "payment",
  PendingVerification: "pending-verification",
  forgot: "forgot",
  ResetPassword: "reset-password",
  corporateList: "corporateList",
  professionalUsers: "professionalUsers",
  AssignProfessional: "assign-professional-to-case",
  OrderHistory: "order-history",
  profile: "profile",
  userProfileForm: "user-profile-form",
  Hotline: "hotline",
  CaseDetails: "case-details",
  AdminUserManagement: "manage-admin",
  RewardProgram: "reward",
  PaymentHistory: "payment-history",
  CaseDashboard: "case-dashboard",
  AllUsers: "all-users",
  PaymentProcess: "payment-process",
  NriSignup: "nri-signup",
  professionalUserListing: "professional-user-list",
  ProfessionalPaymentProcess: "professional-payment-process",
  SuperAdminApproval: "super-admin-approval",
  RewardRedeemRequests: "reward-redeem-requests",
};
